<div class="flex flex-col justify-center items-center gap-4 md:gap-6 pb-4 px-4 md:px-0 max-h-[90vh] overflow-y-auto">
  <div
    class="hidden md:block relative w-full max-w-[720px] aspect-[2.4/1] md:h-[300px] bg-[#344D80] overflow-hidden before:content-[''] before:absolute before:w-[1082px] before:h-[1082px] before:bg-white before:-left-[185px] before:-bottom-[940px] before:rounded-full"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="144"
      height="144"
      viewBox="0 0 144 144"
      fill="none"
      class="absolute top-22 left-68"
    >
      <path
        d="M35.8922 141.624C49.6905 141.624 60.8762 130.438 60.8762 116.64C60.8762 102.842 49.6905 91.656 35.8922 91.656C22.0939 91.656 10.9082 102.842 10.9082 116.64C10.9082 130.438 22.0939 141.624 35.8922 141.624Z"
        fill="#D08790"
      />
      <path
        d="M123.3 43.668C128.808 43.668 133.272 39.2034 133.272 33.696C133.272 28.1886 128.808 23.724 123.3 23.724C117.793 23.724 113.328 28.1886 113.328 33.696C113.328 39.2034 117.793 43.668 123.3 43.668Z"
        fill="#BC4D02"
      />
      <path
        d="M104.472 43.056V15.408C104.472 13.608 103.032 12.132 101.16 12.132H95.0756H89.4236H89.2436C88.5956 12.132 88.0196 12.672 88.0196 13.356V14.508V15.696C88.0196 17.1 86.9756 18.252 85.6436 18.504C85.4636 18.504 85.3196 18.504 85.1396 18.504H81.1796H63.4676C61.9196 18.504 60.6236 17.208 60.6236 15.588V13.248C60.6236 12.6 60.0836 12.024 59.3996 12.024H47.4476C45.6476 12.024 44.1716 13.464 44.1716 15.3L44.0996 81.792V89.388V99.036V128.556C44.0996 130.356 45.5396 131.832 47.3396 131.832H52.4156L100.98 131.904C102.78 131.904 104.292 130.428 104.292 128.628L104.4 43.02L104.472 43.056Z"
        fill="#F3F7FA"
      />
      <path
        d="M101.16 9.10801L47.592 9.03601C43.884 9.03601 40.896 12.024 40.896 15.732L40.752 128.196C40.752 131.904 43.74 134.892 47.448 134.892L100.98 134.964C104.688 134.964 107.676 131.976 107.676 128.268L107.82 15.804C107.82 12.096 104.832 9.10801 101.124 9.10801H101.16ZM104.328 128.664C104.328 130.464 102.852 131.94 101.052 131.94L47.412 131.868C45.612 131.868 44.136 130.392 44.136 128.592L44.28 15.336C44.28 13.536 45.756 12.06 47.556 12.06H59.472C60.156 12.06 60.696 12.636 60.696 13.32V15.66C60.696 17.244 61.992 18.54 63.576 18.54H85.176C86.76 18.54 88.056 17.28 88.056 15.696V13.356C88.056 12.672 88.596 12.132 89.28 12.132H101.196C102.996 12.132 104.472 13.608 104.472 15.444L104.328 128.7V128.664Z"
        fill="#212E4A"
      />
      <path
        d="M71.6407 61.956H117.181C121.861 61.956 125.641 65.412 125.641 69.696V95.94C125.641 100.224 121.861 103.68 117.181 103.68H112.969V115.992C112.969 118.224 109.945 119.268 108.325 117.612L94.7167 103.68H71.6407C66.9607 103.68 63.1807 100.224 63.1807 95.94V69.696C63.1807 65.412 66.9607 61.956 71.6407 61.956Z"
        fill="#8FADD8"
      />
      <path
        d="M72.3604 33.696H26.8204C22.1404 33.696 18.3604 37.152 18.3604 41.436V67.68C18.3604 71.964 22.1404 75.42 26.8204 75.42H31.0324V87.732C31.0324 89.964 34.0564 91.008 35.6764 89.352L49.2844 75.42H72.3604C77.0404 75.42 80.8204 71.964 80.8204 67.68V41.436C80.8204 37.152 77.0404 33.696 72.3604 33.696Z"
        fill="#D0DCEE"
      />
      <path
        d="M36.7921 57.996C38.8201 57.996 40.4641 56.352 40.4641 54.324C40.4641 52.296 38.8201 50.652 36.7921 50.652C34.7641 50.652 33.1201 52.296 33.1201 54.324C33.1201 56.352 34.7641 57.996 36.7921 57.996Z"
        fill="#2C4E84"
      />
      <path
        d="M49.5724 57.996C51.6004 57.996 53.2444 56.352 53.2444 54.324C53.2444 52.296 51.6004 50.652 49.5724 50.652C47.5444 50.652 45.9004 52.296 45.9004 54.324C45.9004 56.352 47.5444 57.996 49.5724 57.996Z"
        fill="#2C4E84"
      />
      <path
        d="M62.424 57.996C64.4519 57.996 66.096 56.352 66.096 54.324C66.096 52.296 64.4519 50.652 62.424 50.652C60.396 50.652 58.752 52.296 58.752 54.324C58.752 56.352 60.396 57.996 62.424 57.996Z"
        fill="#2C4E84"
      />
    </svg>
  </div>
  <p class="pt-4 md:pt-0 font-poppins text-2xl md:text-3xl font-medium text-center">Chat with a vet</p>
  <ul class="space-y-4 md:space-y-6 mb-6 md:mb-10 w-full max-w-md">
    <li class="flex items-start">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <path
          d="M16 32.5C24.753 32.5 32 25.2372 32 16.5C32 7.74705 24.7372 0.5 15.9843 0.5C7.24705 0.5 0 7.74705 0 16.5C0 25.2372 7.26273 32.5 16 32.5Z"
          fill="#207EA7"
        />
        <path
          d="M14.471 23.1667C13.9898 23.1667 13.5934 22.9664 13.2254 22.4657L9.6727 18.0594C9.4604 17.7733 9.33301 17.4585 9.33301 17.1294C9.33301 16.4857 9.8284 15.9564 10.4653 15.9564C10.8758 15.9564 11.1872 16.0851 11.5411 16.5572L14.4144 20.3055L20.4582 10.4914C20.7272 10.0622 21.0952 9.83333 21.4632 9.83333C22.086 9.83333 22.6663 10.2625 22.6663 10.9349C22.6663 11.2496 22.4823 11.5787 22.3124 11.8791L15.66 22.4657C15.3627 22.9378 14.9522 23.1667 14.471 23.1667Z"
          fill="white"
        />
      </svg>
      <div class="ml-3">
        <p class="font-medium">70% of cases resolved</p>
        <p class="text-gray-500">Saving unnecessary practice visits</p>
      </div>
    </li>
    <li class="flex items-start">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <path
          d="M16 32.5C24.753 32.5 32 25.2372 32 16.5C32 7.74705 24.7372 0.5 15.9843 0.5C7.24705 0.5 0 7.74705 0 16.5C0 25.2372 7.26273 32.5 16 32.5Z"
          fill="#207EA7"
        />
        <path
          d="M14.471 23.1667C13.9898 23.1667 13.5934 22.9664 13.2254 22.4657L9.6727 18.0594C9.4604 17.7733 9.33301 17.4585 9.33301 17.1294C9.33301 16.4857 9.8284 15.9564 10.4653 15.9564C10.8758 15.9564 11.1872 16.0851 11.5411 16.5572L14.4144 20.3055L20.4582 10.4914C20.7272 10.0622 21.0952 9.83333 21.4632 9.83333C22.086 9.83333 22.6663 10.2625 22.6663 10.9349C22.6663 11.2496 22.4823 11.5787 22.3124 11.8791L15.66 22.4657C15.3627 22.9378 14.9522 23.1667 14.471 23.1667Z"
          fill="white"
        />
      </svg>
      <div class="ml-3">
        <p class="font-medium">Rapid access</p>
        <p class="text-gray-500">Get chatting to a vet in minutes</p>
      </div>
    </li>
    <li class="flex items-start">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <path
          d="M16 32.5C24.753 32.5 32 25.2372 32 16.5C32 7.74705 24.7372 0.5 15.9843 0.5C7.24705 0.5 0 7.74705 0 16.5C0 25.2372 7.26273 32.5 16 32.5Z"
          fill="#207EA7"
        />
        <path
          d="M14.471 23.1667C13.9898 23.1667 13.5934 22.9664 13.2254 22.4657L9.6727 18.0594C9.4604 17.7733 9.33301 17.4585 9.33301 17.1294C9.33301 16.4857 9.8284 15.9564 10.4653 15.9564C10.8758 15.9564 11.1872 16.0851 11.5411 16.5572L14.4144 20.3055L20.4582 10.4914C20.7272 10.0622 21.0952 9.83333 21.4632 9.83333C22.086 9.83333 22.6663 10.2625 22.6663 10.9349C22.6663 11.2496 22.4823 11.5787 22.3124 11.8791L15.66 22.4657C15.3627 22.9378 14.9522 23.1667 14.471 23.1667Z"
          fill="white"
        />
      </svg>
      <div class="ml-3">
        <p class="font-medium">Tailored treatment plan</p>
        <p class="text-gray-500">Take away a personalised plan for your pets symptoms</p>
      </div>
    </li>
  </ul>

  <p class="font-poppins text-sm leading-normal tracking-028 text-center px-4">
    By continuing, you are confirming you wish to speak about <span class="text-[#207EA7]"> {{ data.petName }}</span>
  </p>

  <button
    type="button"
    (click)="onClick()"
    class="joii-btn-primary md:w-52 w-full max-w-sm md:max-w-none mb-4 md:mb-0"
    data-automationid="vet-care-chat-dialog-chat-button"
  >
    Chat to a vet - {{ data.price / 100 | currency: data.currency : true }}
  </button>
</div>
